import { ref, computed } from "vue";
import { SearchForm, SyainOptions } from "@/types/Syain";
import { SyainService } from "@/service/SyainService";

/*
 * 初期処理
 */
export function useInit() {
  const isError = ref(false)
  const loading = ref(1)
  const searchForm = ref<SearchForm>({} as SearchForm)
  const options = ref({} as SyainOptions)

  const srv = new SyainService();
  // 必要なオプション類を取得する
  srv.getAllOptions().then(opt => {
    if (Object.keys(opt).length < 1) {
      // 成功したらロード数をデクリメント
      isError.value = true;
    }
    options.value = opt;
    loading.value--;
  });

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    isError,
    isLoading,
    options,
    searchForm,
  }
}
